import cn from "@/utils/class-names";
import { useCallback } from "react";
import { PiGridFour, PiListBullets } from "react-icons/pi";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ActionIcon } from "rizzui";

export default function ViewSwitcher() {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const layout = searchParams.get("layout");
    const isGridLayout = layout?.toLowerCase() === "grid";
    const createQueryString = useCallback(
        (name: string, value: string) => {
            const params = new URLSearchParams(searchParams.toString());
            params.set(name, value);
            return params.toString();
        },
        [searchParams],
    );

    const handleLayoutToggle = (view: string) => {
        navigate(`${location.pathname}?${createQueryString("layout", view)}`);
    };

    return (
        <div className="flex items-center gap-2 rounded-lg border border-muted p-1.5 px-1.5">
            <ActionIcon
                size="sm"
                variant="flat"
                className={cn(
                    "group bg-transparent hover:enabled:bg-gray-100 dark:hover:enabled:bg-gray-200",
                    !isGridLayout && "bg-primary",
                )}
                onClick={() => handleLayoutToggle("list")}
            >
                <PiListBullets
                    className={cn(
                        "h-5 w-5 transition-colors group-hover:text-primary",
                        !isGridLayout && "text-primary-foreground",
                    )}
                />
            </ActionIcon>
            <ActionIcon
                size="sm"
                variant="flat"
                className={cn(
                    "group bg-transparent hover:enabled:bg-gray-100 dark:hover:enabled:bg-gray-200",
                    isGridLayout && "bg-primary",
                )}
                onClick={() => handleLayoutToggle("grid")}
            >
                <PiGridFour
                    className={cn(
                        "h-5 w-5 transition-colors group-hover:text-primary",
                        isGridLayout && "text-primary-foreground",
                    )}
                />
            </ActionIcon>
        </div>
    );
}
